export default __webpack_public_path__ + "static/media/profile.75e00f76.jpg";